import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './LoginPage.css';
import companyLogo from './git_icon.png';
import firebase from 'firebase/compat/app';
import emailjs from 'emailjs-com';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';

const sendVerificationConfirmationEmail = (userEmail, userName) => {
  const serviceId = 'service_qfbtx8d';
  const templateId = 'template_bk39pla';
  const userId = 'lfdK4JWd6M0aKkTlF'; // EmailJS user ID

  const templateParams = {
    user_email: userEmail,
    user_name: userName,
  };

  emailjs.send(serviceId, templateId, templateParams, userId)
    .then(response => console.log('Verification confirmation email sent!', response))
    .catch(err => console.error('Failed to send confirmation email:', err));
};

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      // Attempt to sign in the user with email and password
      const userCredential = await firebase.auth().signInWithEmailAndPassword(email, password);
      const user = userCredential.user;

      // Check if the user's email is verified
      if (!user.emailVerified) {
        // If the user's email is not verified, show an alert and sign them out
        await firebase.auth().signOut();
        alert('Please verify your email before logging in. Check your inbox for the verification email.');
        return; // Stop further execution
      }

      // If the email is verified, send confirmation email
      sendVerificationConfirmationEmail(user.email, user.displayName || 'User');

      // Navigate to the home page after verification and confirmation email
      navigate('/home');
      
    } catch (error) {
      console.error('Login Error:', error);

      if (error.code === 'auth/user-not-found') {
        alert('User not found. Please register first.');
      } else if (error.code === 'auth/wrong-password') {
        alert('Incorrect password. Please try again.');
      } else {
        alert('Invalid email or password. Please try again.');
      }
    }
  };

  return (
    <div className="login-container">
      <div className="login-box-1">
        <img src={companyLogo} alt="Company Logo" className="company-logo" />
        <div className="bold-white">Login</div>
        <form>
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <label htmlFor="password">Password</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <button type="button" onClick={handleLogin}>
            Log In
          </button>
          <p>
            Don't have an account? <Link to="/register">Register</Link>
          </p>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
